export function prettifySlug(slug: string): string {
  return slug
    .replace(/-/g, ' ') // Replace dashes with spaces
    .replace(/^\w/, (matchedCharacter) => matchedCharacter.toUpperCase()); // Capitalise first letter of first word
}
